<div class="dialog-title">
  <h2 class="title">
    <mat-icon>place</mat-icon>
    {{'viewer.set_origin'|translate}}
  </h2>

  <span class="spacer"></span>

  <lib-button (click)="close()" icon="close" color="none" textColor="muted" tooltip="{{'viewer.close'|translate}}">
  </lib-button>
</div>

<form [formGroup]="originForm" class="viewer-form" (change)="formData($event)">

  <div class="coordinates-section">
    <!-- Map Coordinates -->
    <div class="coord-group">
      <h4 class="coord-title">
        <mat-icon>map</mat-icon>
        {{'viewer.map_coord'|translate}}
      </h4>

      <div class="coord-row">
        <mat-form-field appearance="outline" class="coord-field" subscriptSizing="dynamic">
          <mat-label>{{'viewer.lon'|translate}}</mat-label>
          <input matInput type="number" formControlName="mapLongitude" id="mapLongitude" step="0.0001">
        </mat-form-field>

        <mat-form-field appearance="outline" class="coord-field" subscriptSizing="dynamic">
          <mat-label>{{'viewer.lat'|translate}}</mat-label>
          <input matInput type="number" formControlName="mapLatitude" id="mapLatitude" step="0.0001">
        </mat-form-field>

        <lib-button color="secondary" icon="my_location" text="{{'viewer.center_here'|translate}}"
          (click)="centerHere()" class="center-btn">
        </lib-button>
      </div>
    </div>

    <!-- Paramètres -->
    <div class="coord-group" *ngIf="isPrivileged()">
      <h4 class="coord-title">
        <mat-icon>settings</mat-icon>
        {{'title.settings'|translate}}
      </h4>

      <div class="coord-row">
        <mat-form-field appearance="outline" class="coord-field" subscriptSizing="dynamic">
          <mat-label>{{'viewer.map_angle'|translate}}</mat-label>
          <input matInput type="number" formControlName="mapAngle" id="mapAngle">
        </mat-form-field>

        <mat-form-field appearance="outline" class="coord-field" subscriptSizing="dynamic">
          <mat-label>{{'viewer.angle_xyz'|translate}}</mat-label>
          <input matInput type="number" formControlName="angle" id="angle">
        </mat-form-field>
      </div>
    </div>

    <!-- Section Options -->
    <div class="options-section">
      <div class="option-item">
        <mat-checkbox formControlName="zoomEnabled" id="zoomEnabled" (change)="checkBoxEvents($event)"></mat-checkbox>
        <span class="option-label">
          <mat-icon>zoom_in</mat-icon>
          {{'viewer.show_zoom'|translate}}
        </span>
      </div>

      <div class="option-item">
        <mat-checkbox formControlName="panEnabled" id="panEnabled" (change)="checkBoxEvents($event)"></mat-checkbox>
        <span class="option-label">
          <mat-icon>open_with</mat-icon>
          {{'viewer.enable_gesture'|translate}}
        </span>
      </div>
    </div>
  </div>
</form>

<mat-dialog-actions>
  <lib-button text="{{'viewer.close'|translate}}" color="outline" icon="close" (click)="close()"></lib-button>
</mat-dialog-actions>
